import React, { Component } from 'react';
import axios from 'axios';
import { shipping_Address, guest_email, get_shipping_method, addressvalidation } from '../../../repository';
import { withCookies, Cookies } from 'react-cookie';
import ReactModal from 'react-modal';
const cookies = new Cookies();

const customStyles = {
    content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginLeft            : '-200px',
        transform             : 'translate(-50%, -50%)',
        padding               : '30px',
        width                 : '400px'
    }
};



ReactModal.setAppElement('#cocoon-basket');

class Shipping extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false,
            errormodalIsOpen: false,
            multipleMatches: false,
            invalidSuite: false,
            missingSuite: false,
            pobox: false,
            user_address_line_1: '',
            user_address_line_2: '',            
            user_address_city: '',
            user_address_state: '',
            user_address_postcode: '',
            user_address_error: '',                        
            user_address_suggested: false,
            user_address_entered: false,
            fedex_failed: false,
            error500: ""
        }
    }
    saveAndContinue = (e) => {
        e.preventDefault()
        this.setState({
            multipleMatches: false,
            invalidSuite: false,
            missingSuite: false,
            pobox: false,
            fedex_failed: false,
            user_address_line_1: '',
            user_address_line_2: '',
            user_address_city: '',
            user_address_state: '',
            user_address_postcode: '',
            user_address_error: ''
        });
        // validate form before proceeding
        const isValid = this.props.validate();
        if (isValid){
            this.props.disable_ship_button(true);
            const csrftoken = cookies.get('csrftoken');    
            let myform = document.getElementById('payment-form').elements;
            const userlang = cookies.get('cbs_language');
            let securityToken;
            if (! cookies.get('userlang') ){
                securityToken = "";
            }else{
                securityToken = myform['csrfmiddlewaretoken'].value;
            }                

            const address = {            
                bypass_validation: "f",
                country: this.props.values.shipping_country,
                first_name: this.props.values.shipping_first_name,
                last_name: this.props.values.shipping_last_name,
                line1: this.props.values.shipping_line1,
                line2: this.props.values.shipping_line2,
                line3: '',
                line4: this.props.values.shipping_line4,
                // method: "standard",
                notes: "",
                phone_number: this.props.values.shipping_phone_number,
                postcode: this.props.values.shipping_postcode,
                state: this.props.values.shipping_state,
                buzzer: this.props.values.buzzer,
                action: 'ship_to'            
            }

            const email = {
                "username": this.props.values.guest_email,
                options: "anonymous",
                password: ""
            }

            const validate_data = {
                country: this.props.values.shipping_country,
                first_name: this.props.values.shipping_first_name,
                last_name: this.props.values.shipping_last_name,
                line1: this.props.values.shipping_line1,
                line2: this.props.values.shipping_line2,                
                line4: this.props.values.shipping_line4,
                phone_number: this.props.values.shipping_phone_number,
                postcode: this.props.values.shipping_postcode,
                state: this.props.values.shipping_state,
                email: this.props.values.guest_email
            }
            addressvalidation(validate_data, securityToken)
            .then((data) => {
                if (data.valid === true){
                    // console.log(`Address validated = `, data.valid);
                    // {"valid":true,"deliverService":"FEDEX_GROUND","transitTime":"ONE_DAY","city":"BRAMPTON","streetLines":["10 NEVETS RD"],"state":"ON","postalCode":"L6T 5T2","countryCode":"CA","residential":false,
                    // "invalidSuite":"false","missingSuite":"false","multipleMatches":"false","pobox":false}
                    if (data.streetLines.length > 1 ) {
                        this.setState({
                            user_address_line_1: data.streetLines[0],
                            user_address_line_2: data.streetLines[1],
                            user_address_city: data.city,
                            user_address_state: data.state,
                            user_address_postcode: data.postalCode
                        });
                    }else{
                        this.setState({
                            user_address_line_1: data.streetLines[0],
                            user_address_line_2: '',
                            user_address_city: data.city,
                            user_address_state: data.state,
                            user_address_postcode: data.postalCode
                        });
                    }                    
                    
                    if (data.invalidSuite === true){
                        // Suite provided was invalid
                        this.setState({
                            invalidSuite: true,
                            user_address_error: this.props.userlang ==='fr'?'Le numéro du bureau inscrit à la 1re ligne de l’adresse d’expédition est inexact ou il ne faut pas de numéro de bureau dans l’adresse donnée.' : 'The suite number entered for Shipping Address Line 1 is either incorrect or the address provided does not require a suite number.'
                        });
                        this.openModal();
                    }else if (data.missingSuite === true){
                        // Suite number is missing, user must provide
                        this.setState({
                            missingSuite: true,
                            user_address_error: this.props.userlang ==='fr'?'Il faut un numéro de bureau dans la 1re ligne de l’adresse d’expédition.' : 'Shipping Address Line 1 requires a suite number'
                        });
                        
                        this.openModal();
                    }else if (data.multipleMatches) {
                        // Address has multiple matches, please enter correct address
                        this.setState({
                            multipleMatches: true,
                            user_address_error: this.props.userlang ==='fr'?'L’adresse inscrite a donné plus d’un résultat de recherche. Vérifiez que l’adresse est exacte et essayez de soumettre le formulaire à nouveau.' : 'The address entered returned more than one potential matches. Please verify your address is correct and try resubmitting the form'
                        });
                        this.openModal();
                    }else if (data.pobox === true){
                        // Address is a PO Box and Cannot be used for delivery
                        this.setState({
                            pobox: true,
                            user_address_error: this.props.userlang ==='fr'?'L’adresse inscrite était une case postale. Nous ne pouvons pas livrer à une case postale.' : 'The address entered was a PO Box. We are unabled to deliver to PO Boxes.'
                        });                        
                        this.openModal();
                    }else if (data.postalCode !== this.props.values.shipping_postcode || data.city.toLowerCase() !== this.props.values.shipping_line4.toLowerCase()){
                        // console.log(`City or postal code don't match`);
                        this.openModal();
                    }else{
                        guest_email(email, securityToken, this.props.userlang)
            
                        // .then( (data) => {
                        //     if (data.Status === true)
                        //         console.log(`Guest Email now in session`, data);
                        // })
                        
                        .then( () => {
                            shipping_Address(address, securityToken, this.props.userlang)        
                                .then( (data) => {
                                    // if (data.Status === true)
                                    //     console.log(`shipping data saved to session`, data);

                                    this.build_summary_address();
                                   return data;  
                                })

                                .then( (data) => {
                                    document.getElementById('shipping_postcode_errors').innerHTML= '';
                                    document.getElementById('shipping_first_name_errors').innerHTML = '';
                                    document.getElementById('shipping_last_name_errors').innerHTML = '';
                                    document.getElementById('shipping_line1_errors').innerHTML = '';
                                    document.getElementById('shipping_line2_errors').innerHTML = '';
                                    document.getElementById('shipping_line4_errors').innerHTML = '';
                                    document.getElementById('shipping_state_errors').innerHTML = '';
                                    document.getElementById('shipping_phone_number_errors').innerHTML = '';
                                    document.getElementById('buzzer_errors').innerHTML = '';
                                    document.getElementById('guest_email_errors').innerHTML = '';

                                    let msg
                                    if (data !== undefined) {                                        
                                        if (data.Status !== true) {                                            
                                            if (this.props.userlang === 'fr') {
                                                msg = "Oups, on dirait que quelque chose s'est mal passé. Veuillez vous assurer que toutes vos informations de contact sont correctes.";
                                            }else{
                                                msg = 'Oops it looks like something went wrong. Please make sure that all of your CONTACT information is correct.';
                                            }

                                            this.setState({
                                                error500: msg
                                            });                                            
                                            this.props.disable_ship_button(false);
                                            this.openErrorModal();
                                        }else{
                                            this.props.get_cbs_language_cookie();
                                            this.props.nextStep();
                                        }   
                                    }else{
                                        if (this.props.userlang === 'fr') {
                                            msg = 'En raison de circonstances imprévues, la méthode de livraison n’a pas été établie. Veuillez réessayer, et si le problème persiste, nous vous prions de communiquer avec l’équipe de soutien.';
                                        }else{
                                            msg = 'Due to an unforseen issue, the Shipping method not set. Please try again and if the problem persist please contact support.';
                                        }
                                        this.setState({
                                            error500: msg
                                        });     
                                        this.props.disable_ship_button(false);                                                                                                       
                                        this.openErrorModal();
                                    }
                                    
                                });

                        });
                    }                    
                } else {
                    // launch modal and display error 
                    // console.log('FedEx Errors ',data);
                    this.setState({
                        fedex_failed: true,
                        user_address_error: data.error_msg
                    });                        
                    this.openModal();
                }
            }); 
            
        }        
        
    }
    
    back  = (e) => {
        e.preventDefault();
        this.props.get_cbs_language_cookie();
        this.props.disable_ship_button(false);
        this.props.disable_delivery_button(false);        
        this.props.disable_billing_button(false);
        this.props.prevStep();
    }

    home = (e) => {
        e.preventDefault();
        this.props.disable_ship_button(false);
        this.props.defaultStep(1);
    }

    build_summary_address = () => {
        const aptcondoNum = this.props.userlang ==='fr'? 'Numéro d’appartement ou de sonnette du condo': 'Apartment/Condo Buzzer Number';
        
        const shippingInfo = "<div>" + this.props.values.shipping_first_name + " " + this.props.values.shipping_last_name + "<br />" + this.props.values.shipping_line1 + "<br /><div>" + this.props.values.shipping_line2 + "</div>" + this.props.values.shipping_line4 + ", " + this.props.values.shipping_state + " " + this.props.values.shipping_postcode + "<br />" + this.props.values.shipping_phone_number +
                            "<br />" + this.props.values.guest_email + "<br /><br />" + aptcondoNum + ": " + this.props.values.buzzer + "</div>";

        // console.log(`shippingInfo `, shippingInfo);
        document.getElementById('checkout-step__summary-address-shipping').innerHTML = shippingInfo;        
    }

    openModal = () => {
        this.setState({modalIsOpen: true});
    }

    openErrorModal = () => {
        this.setState({errormodalIsOpen: true});
    }
    
    afterOpenModal = () =>{
        // references are now sync'd and can be accessed.
        //this.subtitle.style.color = '#f00';
    }
    
    closeModal = () =>{
        this.setState({modalIsOpen: false});
        this.props.disable_ship_button(false);
    }

    closeErrorModal = () =>{
        this.setState({errormodalIsOpen: false});
        this.props.disable_ship_button(false);
    }

    use_input_address = () => {      
        if (document.getElementById('use_suggested_address') !== null)  
            document.getElementById('use_suggested_address').checked = false        
    }


    use_suggested_address = () => {                
        document.getElementById('use_input_address').checked = false                
    }

    conttinueModal = () => {
        const userlang = cookies.get('cbs_language');
        let myform = document.getElementById('payment-form').elements;
        let securityToken;
        this.props.disable_continue_modal(true);
        
        if (window.location.hostname === 'localhost'){
            securityToken = "";
        }else{
            securityToken = myform['csrfmiddlewaretoken'].value;
        }   
        
        // console.log(`State: `, this.state)
        // console.log(`Security token: `, securityToken);
        
        if (document.getElementById('use_suggested_address') != null ) {
            if (document.getElementById('use_suggested_address').checked === true) {
                document.getElementById('shipping_postcode').value = this.state.user_address_postcode;            
                document.getElementById('shipping_line1').value = this.state.user_address_line_1;            
                document.getElementById('shipping_line2').value = this.state.user_address_line_2;            
                document.getElementById('shipping_line4').value = this.state.user_address_city;            
                document.getElementById('shipping_state').value = this.state.user_address_state;            

                this.props.handleChangeValidate(this.state.user_address_line_1, this.state.user_address_line_2, this.state.user_address_city, this.state.user_address_state, this.state.user_address_postcode);
            }            
        }

        const address = {            
            bypass_validation: "f",
            country: this.props.values.shipping_country,
            first_name: this.props.values.shipping_first_name,
            last_name: this.props.values.shipping_last_name,
            line1: this.props.values.shipping_line1,
            line2: this.props.values.shipping_line2,
            line3: '',
            line4: this.props.values.shipping_line4,
            // method: "standard",
            notes: "",
            phone_number: this.props.values.shipping_phone_number,
            postcode: this.props.values.shipping_postcode,
            state: this.props.values.shipping_state,
            buzzer: this.props.values.buzzer,
            action: 'ship_to'            
        }

        const email = {
            "username": this.props.values.guest_email,
            options: "anonymous",
            password: ""
        }

        guest_email(email, securityToken, this.props.userlang)
            
        .then( (data) => {
            // if (data.Status === true)
            //     console.log(`Guest Email now in session`, data);
        })
        
        .then( () => {
            shipping_Address(address, securityToken, this.props.userlang)        
                .then( (data) => {
                    // if (data.Status === true)
                    //     console.log(`shipping data saved to session`, data);
                    this.build_summary_address();

                    return data                                                                                 
                })

                .then( (data) => {
                    document.getElementById('shipping_postcode_errors').innerHTML= '';
                    document.getElementById('shipping_first_name_errors').innerHTML = '';
                    document.getElementById('shipping_last_name_errors').innerHTML = '';
                    document.getElementById('shipping_line1_errors').innerHTML = '';
                    document.getElementById('shipping_line2_errors').innerHTML = '';
                    document.getElementById('shipping_line4_errors').innerHTML = '';
                    document.getElementById('shipping_state_errors').innerHTML = '';
                    document.getElementById('shipping_phone_number_errors').innerHTML = '';
                    document.getElementById('buzzer_errors').innerHTML = '';
                    document.getElementById('guest_email_errors').innerHTML = '';    
                    
                    let msg;
                    if (data !== undefined) {
                        if (data.Status !== true) {
                            
                            if (this.props.userlang === 'fr') {
                                msg = "Oups, on dirait que quelque chose s'est mal passé. Veuillez vous assurer que toutes vos informations de contact sont correctes.";
                            }else{
                                msg = 'Oops it looks like something went wrong. Please make sure that all of your CONTACT information is correct.';
                            }

                            this.setState({
                                error500: msg
                            });                            
                            this.closeModal();
                            this.props.disable_continue_modal(false);
                            this.openErrorModal();
                        }else{
                            this.closeModal();
                            this.props.disable_continue_modal(false);
                            this.props.nextStep();
                        }   
                    }else{
                        if (this.props.userlang === 'fr') {
                            msg = 'En raison de circonstances imprévues, la méthode de livraison n’a pas été établie. Veuillez réessayer, et si le problème persiste, nous vous prions de communiquer avec l’équipe de soutien.';
                        }else{
                            msg = 'Due to an unforseen issue, the Shipping method not set. Please try again and if the problem persist please contact support.';
                        }
                        this.setState({
                            error500: msg
                        });                            
                        this.closeModal();
                        this.props.disable_continue_modal(false);
                        this.openErrorModal();
                    }
                    
                });

        });
    }

    get_child_products = () => {
        if (this.props.step === 1)
            this.props.get_child_products();
        // console.log("Delivery Props", this.props)
    }

    componentDidMount = () => {
        // console.log(this.props);
        this.props.disable_ship_button(false);        
    }

    componentDidUpdate = (prevProps, prevState) => {
            
        // console.log(this.props);

    }    

    render(){
        const { values } = this.props;        
        const child_products = this.get_child_products();  

        return (
            <React.Fragment>
                {/* <!-- Shipping Form/Summary --> */}
                <div className="checkout-step checkout-step--shipping-address form">
                    <h2 className="checkout-step__heading">1. {this.props.userlang ==='fr'? 'Expédition': 'Shipping'} </h2>
                    <div className={this.props.step > 1? 'checkout-step__body checkout-step__body--collapsed' :'checkout-step__body'}>
                        <form className="form">
                            <div className="form__field"></div>
                            <div className="form__field"></div>
                            <div
                                className="form__field form__field--optional form__field--text form__field--shipping_first_name form__field--not-blank">
                                <label className="form__label form__label--dynamic" htmlFor="shipping_first_name">{this.props.userlang ==='fr'? 'Nom': 'First Name'}</label> <input id="shipping_first_name" name="shipping_first_name"
                                    autoComplete="given-name" maxLength="25" type="text" onChange={this.props.handleChange('shipping_first_name')} defaultValue={values.shipping_first_name}   />
                                    <ul id="shipping_first_name_errors" className="form__error-list"></ul>
                            </div>
                            <div
                                className="form__field form__field--optional form__field--text form__field--shipping_last_name form__field--not-blank">
                                <label className="form__label form__label--dynamic" htmlFor="shipping_last_name">{this.props.userlang ==='fr'? 'Prénom': 'Last Name'}</label><input id="shipping_last_name" name="shipping_last_name"
                                    autoComplete="family-name" maxLength="25" type="text"onChange={this.props.handleChange('shipping_last_name')} defaultValue={values.shipping_last_name}  />
                                    <ul id="shipping_last_name_errors" className="form__error-list"></ul>
                            </div>
                            <div
                                className="form__field form__field--optional form__field--text form__field--shipping_line1 form__field--not-blank">
                                <label className="form__label form__label--dynamic" htmlFor="shipping_line1">{this.props.userlang ==='fr'? '1re ligne de l’adresse': 'Address Line 1'}</label><input id="shipping_line1" name="shipping_line1"
                                    autoComplete="off" placeholder="" maxLength="25" type="text" onChange={this.props.handleChange('shipping_line1')} defaultValue={values.shipping_line1}  />
                                    <ul id="shipping_line1_errors" className="form__error-list"></ul>
                            </div>
                            <div
                                className="form__field form__field--optional form__field--text form__field--shipping_line2 form__field--not-blank">
                                <label className="form__label form__label--dynamic"
                                    htmlFor="shipping_line2">{this.props.userlang ==='fr'? 'Appartement, bureau ou autre': 'Apartment/Suite/Other'}</label><input id="shipping_line2"
                                    name="shipping_line2" autoComplete="address-line2" maxLength="25" type="text" onChange={this.props.handleChange('shipping_line2')} defaultValue={values.shipping_line2} />
                                    <ul id="shipping_line2_errors" className="form__error-list"></ul>
                            </div>
                            <div
                                className="form__field form__field--optional form__field--text form__field--shipping_line4 form__field--not-blank">
                                <label className="form__label form__label--dynamic"
                                    htmlFor="shipping_line4">{this.props.userlang ==='fr'? 'Ville': 'City'}</label><input id="shipping_line4"
                                    name="shipping_line4" autoComplete="address-level2" maxLength="60" type="text" onChange={this.props.handleChange('shipping_line4')} defaultValue={values.shipping_line4}  />
                                    <ul id="shipping_line4_errors" className="form__error-list"></ul>
                            </div>
                            <div
                                className="form__field form__field--optional form__field--choice form__field--shipping_state form__field--not-blank">
                                <label className="form__label form__label--dynamic"
                                    htmlFor="shipping_state">{this.props.userlang ==='fr'? 'Province': 'Province'}</label> <select id="shipping_state"
                                    name="shipping_state" autoComplete="address-level1"onChange={this.props.handleChange('shipping_state')} defaultValue={values.shipping_state}  >
                                    <option value=""></option>
                                    <option value="AB">Alberta</option>
                                    <option value="BC">British Columbia</option>
                                    <option value="MB">Manitoba</option>
                                    <option value="NB">New Brunswick</option>
                                    <option value="NL">Newfoundland and Labrador</option>
                                    <option value="NS">Nova Scotia</option>
                                    <option value="ON">Ontario</option>
                                    <option value="PE">Prince Edward Island</option>
                                    <option value="QC">Quebec</option>
                                    <option value="SK">Saskatchewan</option>
                                    <option value="NT">Northwest Territories</option>
                                    <option value="NU">Nunavut</option>
                                    <option value="YT">Yukon</option>
                                </select>
                                <ul id="shipping_state_errors" className="form__error-list"></ul>
                            </div>
                            <div
                                className="form__field form__field--optional form__field--text form__field--shipping_postcode form__field--not-blank">
                                <label className="form__label form__label--dynamic">{this.props.userlang ==='fr'? 'Code postal': 'Postal Code'}</label><input
                                    name="shipping_postcode" id="shipping_postcode" autoComplete="postal-code" maxLength="7" type="text" onChange={this.props.handleChange('shipping_postcode')} defaultValue={values.shipping_postcode}  />
                                    <ul id="shipping_postcode_errors" className="form__error-list"></ul>
                            </div>
                            <div
                                className="form__field form__field--optional form__field--choice form__field--shipping_country form__field--not-blank">
                                <label className="form__label form__label--dynamic">{this.props.userlang ==='fr'? 'Pays': 'Country'}</label><select
                                    name="shipping_country" autoComplete="country" onChange={this.props.handleChange('shipping_country')} defaultValue={values.shipping_country}>
                                    <option value="CA">Canada</option>
                                </select></div>
                            <div
                                className="form__field form__field--optional form__field--phone form__field--shipping_phone_number form__field--not-blank">
                                <label className="form__label form__label--dynamic">{this.props.userlang ==='fr'? 'Téléphone': 'Phone Number'}</label><input
                                    type="tel" autoComplete="tel" name="shipping_phone_number"                                                                      
                                    placeholder="1-###-###-####" 
                                    onChange={this.props.handleChange('shipping_phone_number')} 
                                    defaultValue={values.shipping_phone_number}  
                                    />
                                    <ul id="shipping_phone_number_errors" className="form__error-list"></ul>
                            </div>
                            <div
                                className="form__field form__field--optional form__field--phone form__field--shipping_phone_number form__field--not-blank">
                                <label className="form__label form__label--dynamic">{this.props.userlang ==='fr'? 'Numéro d’appartement ou de sonnette du condo': 'Apartment/Condo Buzzer Number'}</label><input
                                    type="text" name="buzzer" onChange={this.props.handleChange('buzzer')} defaultValue={values.buzzer} />
                                    <ul id="buzzer_errors" className="form__error-list"></ul>
                            </div>
                            <div>
                                <div
                                    className="form__field form__field--optional form__field--text form__field--guest_email form__field--not-blank">
                                    <label className="form__label form__label--dynamic" htmlFor="guest_email">{this.props.userlang ==='fr'? 'Adresse courriel': 'Email Addres'}s</label><input id="guest_email" name="guest_email" type="email" onChange={this.props.handleChange('guest_email')} defaultValue={values.guest_email} />
                                        <ul id="guest_email_errors" className="form__error-list"></ul>
                                </div>
                            </div>
                            <div className="form__field form__field--submit"><input type="submit"
                                    className="button button--full-width button--continue-to-delivery"
                                    value={this.props.userlang ==='fr'? 'Poursuivre vers Livraison': 'Continue to Delivery'} onClick={this.saveAndContinue} disabled={this.props.submit_shipping?true:false} /></div>
                        </form>
                    </div>
                    <div className={this.props.step === 1? "checkout-step__summary checkout-step__summary--collapsed" :"checkout-step__summary"}>
                        <h3 className="checkout-step__label">{this.props.userlang ==='fr'? 'Ship to': 'Ship to'}:</h3>
                        <div className="checkout-step__summary-address" id="checkout-step__summary-address-shipping"><br /><br />
                            <div></div><br />
                            <br /><br />
                        </div><a className="checkout-step__back" href="#" onClick={
                            
                            this.props.step > 2? this.home : this.back

                            }>{this.props.userlang ==='fr'? 'Modifier': 'Edit'}</a>
                    </div>
                </div>
                {/* <!-- End of Shipping Form/Summary -->*/}
                <ReactModal
                    isOpen={
                        this.state.modalIsOpen
                    }

                    closeTimeoutMS={
                        0
                    }

                    ariaHideApp={
                        true
                    }         
                    
                    aria={
                        {
                          label: this.props.userlang ==='fr'? 'Vérification de l’adresse': 'Address Verification',
                          labelledby: "address-verification",
                          describedby: "address-verification-description",
                          modal: true
                        }
                    }

                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    style={customStyles}
                >
                    <button className="address-suggestion-model__close" aria-label="close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="38.286" height="38.286" viewBox="0 0 38.286 38.286" className="address-suggestion-model__close--icon" onClick={this.closeModal}>
                            <title>Close Icon</title>
                            <g id="Group_394" data-name="Group 394" transform="translate(-7260 -993)">
                                <g id="Ellipse_1" data-name="Ellipse 1" transform="translate(7260 993)" fill="#fff" stroke="#1b63cc" strokeWidth="3">
                                    <circle cx="19.143" cy="19.143" r="19.143" stroke="none"></circle>
                                    <circle cx="19.143" cy="19.143" r="17.643" fill="none"></circle>
                                </g>
                                <g id="Group_262" data-name="Group 262" transform="translate(7272.742 1004.506)">
                                    <line id="Line_1" data-name="Line 1" x2="10.245" y2="12.166" transform="translate(1.258 1.494)" fill="none" stroke="#1b63cc" strokeLinecap="round" strokeWidth="3"></line>
                                    <line id="Line_2" data-name="Line 2" x1="10.245" y2="12.166" transform="translate(1.258 1.494)" fill="none" stroke="#1b63cc" strokeLinecap="round" strokeWidth="3"></line>
                                </g>
                            </g>
                        </svg>
                    </button>
                    <div className="address-suggestion-model">
                        <h1 className="ada-screenreader-only" id="address-verification">{this.props.userlang ==='fr'? 'Vérification de l’adresse': 'Address Verification'}</h1>
                        <h2 className="address-suggestion-model__header" id="address-verification-description">{this.props.userlang ==='fr'? 'Vérifiez l’adresse': 'Please verify your address'}</h2>
                        <fieldset className="address-suggestion-model__form">
                            {
                                this.state.pobox === true || this.state.multipleMatches === true || this.state.invalidSuite === true || this.state.missingSuite === true || this.state.fedex_failed === true? 
                                <legend>
                                <p>{this.props.userlang ==='fr'? 'Des erreurs ont été décelées dans l’adresse que vous avez soumise': 'Errors were found in your address submission'}.</p>
                                </legend>: 
                                <legend>
                                    <p>{this.props.userlang ==='fr'? 'FedEx vous conseille d’utiliser plutôt cette adresse': 'FedEx recommends using this address'}.</p>
                                </legend>
                            } 
                            {
                                this.state.user_address_error !== ''?
                                <p className='error'>{this.state.user_address_error}</p>
                                :''
                            }      

                            {
                                this.state.pobox === true || this.state.multipleMatches === true  || this.state.missingSuite === true? '':
                                
                                <React.Fragment> 
                                {
                                    this.state.invalidSuite === true  || this.state.missingSuite === true || this.state.fedex_failed === true?
                                    '':
                                    <label htmlFor="use_suggested_address">
                                        <input type="radio" name="use_suggested_address" id="use_suggested_address" onChange={this.use_suggested_address} checked={true} /> <span className="address-suggestion-model__radio-title">
                                        {this.props.userlang ==='fr'? 'Utiliser l’adresse proposée par FedEx': 'Use the address suggested by FedEx'}:</span>
                                        <p className="address-suggestion-model__address">
                                            <span className="address-suggestion-model__address-line">{this.props.values.shipping_first_name} {this.props.values.shipping_last_name}</span>
                                            <span className="address-suggestion-model__address-line">{this.state.user_address_line_1} {this.state.user_address_line_2 !== ''? this.state.user_address_line_2: ''}</span>
                                            <span className="address-suggestion-model__address-line">{this.state.user_address_city}, {this.state.user_address_state} {this.state.user_address_postcode}</span>
                                        </p>
                                    </label>
                                }                                  

                                <label htmlFor="use_input_address">
                                    <input type="radio" name="use_input_address" id="use_input_address" onChange={this.use_input_address} /> <span className="address-suggestion-model__radio-title">{this.props.userlang ==='fr'? 'L’adresse inscrite était une case postale. Nous ne pouvons pas livrer à une case postale.': 'Use the address you entered'}:</span>
                                    <p className="address-suggestion-model__address">
                                        <span className="address-suggestion-model__address-line">{this.props.values.shipping_first_name} {this.props.values.shipping_last_name}</span>
                                        <span className="address-suggestion-model__address-line">{this.props.values.shipping_line1}</span>
                                        {
                                            this.props.values.shipping_line2?<span className="address-suggestion-model__address-line">{this.props.values.shipping_line2}</span>:''
                                        }                                    
                                        <span className="address-suggestion-model__address-line">{this.props.values.shipping_line4}, {this.props.values.shipping_state} {this.props.values.shipping_postcode}</span>
                                    </p>
                                </label>
                                </React.Fragment>   
                            }                                                                             
                        </fieldset>
                        {
                            this.state.pobox === true || this.state.multipleMatches === true  || this.state.missingSuite === true? '': 
                            <button className="address-suggestion-model__continue button" onClick={this.conttinueModal} disabled={this.props.continue_fedex_modal?true:false}><span>{this.props.userlang ==='fr'? 'CONTINUE': 'CONTINUE'}</span></button>
                        }                        
                    </div>
                </ReactModal>
                <ReactModal
                    isOpen={
                        this.state.errormodalIsOpen
                    }

                    closeTimeoutMS={
                        0
                    }

                    ariaHideApp={
                        true
                    }         
                    
                    aria={
                        {
                          label: "",
                          labelledby: "address-verification",
                          describedby: "address-verification-description",
                          modal: true
                        }
                    }
                    
                    onRequestClose={this.closeErrorModal}
                    style={customStyles}
                >
                    <button className="address-suggestion-model__close" aria-label="close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="38.286" height="38.286" viewBox="0 0 38.286 38.286" className="address-suggestion-model__close--icon" onClick={this.closeErrorModal}>
                            <title>Close Icon</title>
                            <g id="Group_394" data-name="Group 394" transform="translate(-7260 -993)">
                                <g id="Ellipse_1" data-name="Ellipse 1" transform="translate(7260 993)" fill="#fff" stroke="#1b63cc" strokeWidth="3">
                                    <circle cx="19.143" cy="19.143" r="19.143" stroke="none"></circle>
                                    <circle cx="19.143" cy="19.143" r="17.643" fill="none"></circle>
                                </g>
                                <g id="Group_262" data-name="Group 262" transform="translate(7272.742 1004.506)">
                                    <line id="Line_1" data-name="Line 1" x2="10.245" y2="12.166" transform="translate(1.258 1.494)" fill="none" stroke="#1b63cc" strokeLinecap="round" strokeWidth="3"></line>
                                    <line id="Line_2" data-name="Line 2" x1="10.245" y2="12.166" transform="translate(1.258 1.494)" fill="none" stroke="#1b63cc" strokeLinecap="round" strokeWidth="3"></line>
                                </g>
                            </g>
                        </svg>
                    </button>
                    <div className="address-suggestion-model">
                    <h1 className="ada-screenreader-only" id="address-verification">{this.props.userlang ==='fr'? 'Message d’erreur': 'Error Message'}</h1>                     
                    <p className='error'>{this.state.error500}</p>
                    </div>
                </ReactModal>
            </React.Fragment>            
        );
    }
}      

document.getElementById('cocoon-basket');

export default Shipping;